/**
 * Defers heavy third-party app scripts until idle/interaction,
 * and holds Instagram scripts until the feed section is near the viewport.
 * Stylesheets are left alone so widget UI still paints correctly when JS starts.
 */
(function () {
  var DEFER_RE = /instagram-story|judge\.me|judgeme/i;
  var queue = [];
  var released = {
    instagram: false,
    reviews: false
  };

  function groupFor(src) {
    if (/instagram-story/i.test(src)) return 'instagram';
    if (/judge\.me|judgeme/i.test(src)) return 'reviews';
    return 'other';
  }

  function parkScript(node) {
    if (!node || node.tagName !== 'SCRIPT') return;
    if (node.getAttribute('data-cc-deferred') === '1') return;
    var src = node.src || node.getAttribute('src') || '';
    if (!src || !DEFER_RE.test(src)) return;
    var group = groupFor(src);
    if (released[group]) return;

    node.setAttribute('data-cc-deferred', '1');
    node.setAttribute('data-cc-defer-src', src);
    node.setAttribute('data-cc-defer-group', group);
    node.type = 'text/cc-deferred';
    try {
      node.removeAttribute('src');
    } catch (e) {}
    queue.push(node);
  }

  function inject(node) {
    var src = node.getAttribute('data-cc-defer-src');
    if (!src || node.getAttribute('data-cc-injected') === '1') return;
    node.setAttribute('data-cc-injected', '1');
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute('data-cc-restored', '1');
    (document.head || document.documentElement).appendChild(s);
  }

  function release(group) {
    if (released[group]) return;
    released[group] = true;
    queue.forEach(function (node) {
      if (node.getAttribute('data-cc-defer-group') === group) inject(node);
    });
  }

  window.__ccDeferApps = {
    release: release,
    releaseLight: function () {
      release('reviews');
    },
    releaseInstagram: function () {
      release('instagram');
    }
  };

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) parkScript(nodes[j]);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (document.querySelectorAll) {
    document.querySelectorAll('script[src]').forEach(parkScript);
  }
})();
